$(() => {
    $('input:file').change(function() {
		var fileName = $(this).val().replace('C:\\fakepath\\', '');
		$($(this).parent().children('.custom-file-label')).html(fileName);
	});
});